<template>
  <wiskItemsGrid
    :gridStyle="gridStyle"
    :columns="columns"
    :items="displayItems"
    :loading="loading"
    :header="header"
    :customFilter="customFilterSelected"
    :options="{ rowSelection: { mode: 'multiRow', checkboxes: true }, rowClassRules: { 'warning-row': 'data?.varianceRecalculating' } }"
    :excel="{ fileName: excelFileName }"
    :additionalHeaderCols="4"
    :additionalHeaderColsMobile="8"
    :parentGridName="parentGridName"
    :defaultFilter="{ predicate: item => !!item, name: 'all', label: 'All' }"
  >
    <template v-slot:additional-controls>
      <wiskGridCustomFilterDropdown :customFilters="customFilters" v-model="customFilterSelected" class="" />
    </template>
  </wiskItemsGrid>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import wiskItemsGrid from '@/components/grids/WiskItemsGrid'
import getVarianceColumns from './varianceColumns'
import { getVarianceCustomFilters, getVariancePerMonthCustomFilters, VARIANCE_FILTER_INCLUDING_BOTTLES_WITHOUT_CONSUMPTION_OR_SALES } from './gridFilters'

export default {
  name: 'VarianceGrid',
  components: { wiskItemsGrid },
  emits: ['refresh', 'openDetails'],
  props: {
    items: { type: Array, default: () => [] },
    bottlesWithoutConsumptionOrSales: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    gridStyle: { type: Object, default: () => ({}) },
    selectedRange: { type: Object, default: () => ({}) },
    header: { type: Object, default: () => ({}) },
    independentInventory: Boolean,
    parentGridName: { type: String, default: 'Variance' },
    excelFileName: { type: String, default: 'Variance' },
    variancePerMonth: Boolean
  },
  data() {
    return {
      customFilterSelected: null,
      customFilters: [],
      columns: {},
    }
  },
  computed: {
    ...mapState(['translations', 'venue', 'bottlesById', 'itemVariantsById']),
    ...mapGetters([]),
    displayItems() {
      if (this.customFilterSelected?.name === VARIANCE_FILTER_INCLUDING_BOTTLES_WITHOUT_CONSUMPTION_OR_SALES) {
        return [...this.items, ...this.bottlesWithoutConsumptionOrSales]
      }
      return this.items
    }
  },
  methods: {
    ...mapActions(['setGlobalAction']),
    emitRefresh(itemId) {
      this.$emit('refresh', itemId)
    },
    openDetails(id) {
      this.$emit('openDetails', id)
    }
  },
  created() {
    this.customFilters = this.variancePerMonth
      ? getVariancePerMonthCustomFilters(this.translations)
      : getVarianceCustomFilters(this.translations)
  },
  watch: {
    selectedRange: {
      handler(selectedRange) {
        if (selectedRange?.inventory_range?.start_inventory_id && selectedRange?.inventory_range?.end_inventory_id) {
          this.columns = getVarianceColumns({
            translations: this.translations,
            setGlobalAction: this.setGlobalAction,
            startInventoryId: selectedRange.inventory_range.start_inventory_id,
            endInventoryId: selectedRange.inventory_range.end_inventory_id,
            emitRefresh: this.emitRefresh,
            openDetails: !this.independentInventory && this.openDetails,
            defaultUMVolume: this.venue.default_um_volume,
            defaultUMWeight: this.venue.default_um_weight,
            variancePerMonth: this.variancePerMonth
          })
        }
      },
      deep: true,
      immediate: true
    },
  }
}
</script>

<style lang="scss"></style>
